<template>
  <el-dialog title="Edit Finance Info" :close-on-click-modal="false" :visible.sync="visible" width="1000px" top="3vh">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" autocomplete="off" label-position="top">
      <el-row :gutter="20">
        <template v-if="isMalaysia">
          <!-- Registered Address -->
          <el-col :span="24" class="mb10">
            <el-form-item label="Registered Address" prop="registeredOfficeType">
              <el-radio-group v-model="dataForm.registeredOfficeType" class="wdb100">
                <div class="pt10" v-if="nativeRegisteredAddress.length">
                  <el-radio :label="1">Consent to use EStar Business Sdn. Bhd. ("EStar")'s registration address</el-radio>
                  <el-form-item prop="registeredOfficeId" class="native-office-item" v-if="dataForm.registeredOfficeType === 1">
                    <el-radio-group v-model="dataForm.registeredOfficeId">
                      <el-radio v-for="office in nativeRegisteredAddress" :key="office.id" :label="office.id">
                        <span class="native-addr-text">{{ formatNativeAddress(office) }}</span>
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
                <div class="pt12">
                  <el-radio :label="2">Use other registration address</el-radio>
                </div>
                <div v-if="dataForm.registeredOfficeType === 2" class="address-form">
                  <el-row :gutter="20">
                    <el-col :span="8">
                      <el-form-item label="Address line 1" prop="registeredOfficeAddressLine1" size="small">
                        <el-input v-model="dataForm.registeredOfficeAddressLine1" placeholder="Please enter"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="Address line 2" prop="registeredOfficeAddressLine2" size="small">
                        <el-input v-model="dataForm.registeredOfficeAddressLine2" placeholder="Please enter"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="Address line 3" prop="registeredOfficeAddressLine3" size="small">
                        <el-input v-model="dataForm.registeredOfficeAddressLine3" placeholder="Please enter"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="6">
                      <el-form-item label="Country" prop="registeredOfficeCountry" size="small">
                        <el-input v-model="dataForm.registeredOfficeCountry" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="State" prop="registeredOfficeState" size="small">
                        <el-select v-model="dataForm.registeredOfficeState" placeholder="Select" filterable class="wdb100">
                          <el-option v-for="item in stateOptions" :key="item.value" :label="item.title" :value="item.value"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="City" prop="registeredOfficeCity" size="small">
                        <el-input v-model="dataForm.registeredOfficeCity" placeholder="Please enter"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="Code" prop="registeredOfficePostalCode" size="small">
                        <el-input v-model="dataForm.registeredOfficePostalCode" placeholder="Please enter"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <!-- Service Address -->
          <el-col :span="24" class="mb14">
            <el-form-item label="Service Address" prop="serviceAddressType">
              <el-radio-group v-model="dataForm.serviceAddressType" class="wdb100">
                <div class="pt10">
                  <el-radio :label="1">Same As Registered Address</el-radio>
                </div>
                <div class="pt12">
                  <el-radio :label="2">Use other service address</el-radio>
                </div>
                <div v-if="dataForm.serviceAddressType === 2" class="address-form">
                  <el-row :gutter="20">
                    <el-col :span="8">
                      <el-form-item label="Address line 1" prop="serviceAddressLine1" size="small">
                        <el-input v-model="dataForm.serviceAddressLine1" placeholder="Please enter"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="Address line 2" prop="serviceAddressLine2" size="small">
                        <el-input v-model="dataForm.serviceAddressLine2" placeholder="Please enter"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="Address line 3" prop="serviceAddressLine3" size="small">
                        <el-input v-model="dataForm.serviceAddressLine3" placeholder="Please enter"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="6">
                      <el-form-item label="Country" prop="serviceAddressCountry" size="small">
                        <el-input v-model="dataForm.serviceAddressCountry" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="State" prop="serviceAddressState" size="small">
                        <el-select v-model="dataForm.serviceAddressState" placeholder="Select" filterable class="wdb100">
                          <el-option v-for="item in stateOptions" :key="item.value" :label="item.title" :value="item.value"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="City" prop="serviceAddressCity" size="small">
                        <el-input v-model="dataForm.serviceAddressCity" placeholder="Please enter"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="Code" prop="serviceAddressPostalCode" size="small">
                        <el-input v-model="dataForm.serviceAddressPostalCode" placeholder="Please enter"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </template>
        <template v-if="businessType == 'COMPANY_INCORPORATION'">
          <el-col :span="24">
            <p class="mt0 mb0 fs14 fwb black45">
              <i class="red">*</i>
              Financial Year End (e.g. 31 December)
            </p>
          </el-col>
          <el-col :span="12">
            <div class="lh38">Month</div>
            <el-form-item prop="month">
              <el-select v-model="dataForm.month" placeholder="Select" class="wdb100">
                <el-option v-for="nub in 12" :key="'month' + nub" :label="nub" :value="nub"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <div class="lh38">Date</div>
            <el-form-item prop="date">
              <el-select v-model="dataForm.date" placeholder="Select" class="wdb100">
                <el-option v-for="nub in 31" :key="'date' + nub" :label="nub" :value="nub"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Financial Year Period" prop="financialYearPeriod">
              <el-select v-model="dataForm.financialYearPeriod" clearable placeholder="Select" class="wdb100">
                <el-option v-for="item in financialYearPeriodOption" :key="item.value" :label="item.title" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </template>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit()">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import PrefixPhone from "@/components/PrefixPhone";
import { validateFormLocation } from "@/utils";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  props: {
    businessType: {
      type: String,
    },
    country: {
      type: String,
      default: "",
    },
    nativeRegisteredAddress: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    PrefixPhone,
  },
  data() {
    return {
      visible: false,
      dataForm: {
        id: 0,
        month: null,
        date: null,
        financialYearEnd: "",
        financialYearPeriod: "",
        // Malaysia fields
        registeredOfficeType: null,
        registeredOfficeId: null,
        registeredOfficeAddressLine1: null,
        registeredOfficeAddressLine2: null,
        registeredOfficeAddressLine3: null,
        registeredOfficeCountry: "Malaysia",
        registeredOfficeState: null,
        registeredOfficeCity: null,
        registeredOfficePostalCode: null,
        serviceAddressType: null,
        serviceAddressLine1: null,
        serviceAddressLine2: null,
        serviceAddressLine3: null,
        serviceAddressCountry: "Malaysia",
        serviceAddressState: null,
        serviceAddressCity: null,
        serviceAddressPostalCode: null,
      },
      submitLoading: false,
    };
  },
  computed: {
    ...mapGetters("constant", ["byCountryFormatList", "getApplyStep"]),
    isMalaysia() {
      return this.country === "Malaysia";
    },
    msicOptions() {
      return this.byCountryFormatList("tradeData", "Malaysia");
    },
    stateOptions() {
      return this.byCountryFormatList("provinceOrStateData", "Malaysia");
    },
    financialYearPeriodOption() {
      return this.byCountryFormatList("financialPeriodTypeData", this.country);
    },
    dataRule() {
      const rule = {
        month: [{ required: true, message: "please select", trigger: "submit" }],
        date: [{ required: true, message: "please select", trigger: "submit" }],
        financialYearPeriod: [{ required: true, message: "please select", trigger: "submit" }],
      };
      if (this.isMalaysia) {
        Object.assign(rule, {
          registeredOfficeType: [{ required: true, message: "please select", trigger: "submit" }],
          registeredOfficeId: [{ required: true, message: "please select", trigger: "submit" }],
          registeredOfficeAddressLine1: [{ required: true, message: "please enter", trigger: "submit" }],
          registeredOfficeState: [{ required: true, message: "please select", trigger: "submit" }],
          registeredOfficeCity: [{ required: true, message: "please enter", trigger: "submit" }],
          registeredOfficePostalCode: [{ required: true, message: "please enter", trigger: "submit" }],
          serviceAddressType: [{ required: true, message: "please select", trigger: "submit" }],
          serviceAddressLine1: [{ required: true, message: "please enter", trigger: "submit" }],
          serviceAddressState: [{ required: true, message: "please select", trigger: "submit" }],
          serviceAddressCity: [{ required: true, message: "please enter", trigger: "submit" }],
          serviceAddressPostalCode: [{ required: true, message: "please enter", trigger: "submit" }],
        });
      }
      return rule;
    },
    monthOptions() {
      let yearArr = [];
      for (let i = 1; i <= 31; i++) {
        let childrenArr = [];
        for (let j = 1; j <= 12; j++) {
          childrenArr.push({ value: `Month ${j}`, label: `Month ${j}` });
        }
        yearArr.push({ value: `Date ${i}`, label: `Date ${i}`, children: childrenArr });
      }
      return yearArr;
    },
  },
  methods: {
    ...mapActions("applyment", ["doSaveRevising"]),
    async init(data) {
      this.submitLoading = false;
      this.visible = true;
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      const copy = JSON.parse(JSON.stringify(data));
      const financialYearEndCopy = copy.financialYearEnd;
      const financialYearEndSplit = financialYearEndCopy && financialYearEndCopy.includes("/") ? financialYearEndCopy.split("/") : null;
      copy.month = financialYearEndSplit ? parseInt(financialYearEndSplit[0]) : null;
      copy.date = financialYearEndSplit ? parseInt(financialYearEndSplit[1]) : null;
      if (this.isMalaysia) {
        copy.registeredOfficeCountry = copy.registeredOfficeCountry || "Malaysia";
        copy.serviceAddressCountry = copy.serviceAddressCountry || "Malaysia";
        copy.registeredOfficeId = copy.registeredOfficeId || null;
      }
      this.dataForm = copy;
    },
    formatNativeAddress(office) {
      const addressParts = office.addressLine1
        ? [office.addressLine1, office.addressLine2, office.addressLine3].filter(Boolean)
        : [office.address].filter(Boolean);
      const line1 = addressParts.join(", ");
      const line2 = [office.country, office.state, office.city, office.postalCode].filter(Boolean).join(", ");
      return line1 + "\n" + line2;
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate(async (valid, object) => {
        if (valid) {
          this.submitLoading = true;
          let dataFormCopy = JSON.parse(JSON.stringify(this.dataForm));
          let financialYearEndRes = this.dataForm.month && this.dataForm.date ? `${this.dataForm.month}/${this.dataForm.date}` : "";
          dataFormCopy.financialYearEnd = financialYearEndRes;

          this.doSaveRevising({
            ...dataFormCopy,
            procedure: {
              step: this.getApplyStep("companyDetails"),
            },
          })
            .then(() => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.visible = false;
                },
              });
            })
            .catch(msg => {
              this.submitLoading = false;
            });
        } else {
          validateFormLocation(object, this.$refs["dataForm"]);
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.native-addr-text {
  font-size: 12px;
  line-height: 16px;
  white-space: pre-line;
  display: inline-block;
  vertical-align: middle;
}

.native-office-item {
  margin-left: 24px;
  margin-top: 6px;
  margin-bottom: 0;
}

::v-deep {
  .address-form {
    padding-top: 6px;
    margin-left: 24px;

    .el-form-item--small {
      margin-bottom: 12px !important;

      .el-form-item__label {
        font-size: 12px !important;
        line-height: 24px !important;
        font-weight: 400 !important;
      }
    }
  }
}
</style>
